/**
 * https://material.angular.io/components/input/overview
 * Changing when error messages are shown
 */
import { ErrorStateMatcher } from '@angular/material/core';
import { UntypedFormControl, FormGroupDirective, NgForm } from '@angular/forms';

/**
 * ReactiveFormの入力チェックが初回表示時に起動しない問題の対応ディレクティブ
 * リアクティブフォームでmaxLengthを指定した際に、<mat-error>によるエラー検知が
 * 初回のみフォーカスロストしないと動作しない問題の対応
 * @export
 * @class ImmediatelyErrorStateMatcher
 * @implements {ErrorStateMatcher}
 */
export class ImmediatelyErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(control: UntypedFormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    const isSubmitted = form && form.submitted;
    return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
  }
}